import React from 'react';
import { Box, Paper, Typography, Zoom } from '@mui/material';

interface ChartCardProps {
  title: string;
  timeout?: number;
  minHeight?: { xs: number; md: number };
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  timeout = 1500,
  minHeight = { xs: 260, md: 320 },
  children,
}) => (
  <Zoom in timeout={timeout}>
    <Paper
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: '18px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ flex: 1, minHeight }}>
        {children}
      </Box>
    </Paper>
  </Zoom>
);

export default ChartCard;
